<template>
    <div class="top">
        <a href="javascript:history.go(-1);" class="back" v-if="isZgapp && isApp || !isZgapp && isIos || !isZgapp && isAndroid">
            <i class="el-icon-arrow-left"></i>
        </a>
        {{title}}
    </div>
</template>

<script>

export default{
    name: 'Top',
    props:{
        title: String     
    },
    data(){
        return{
            isZgapp: window.navigator.userAgent.indexOf('ZgApp') >= 0,
            isAndroid: window.navigator.userAgent.indexOf('Android') >= 0,
            isIos: !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        }
    }
}
</script>

<style lang="less" scoped>
    .top{
        position: fixed;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: #fff;
        font-size: 0.43rem;
        font-weight: bold;
        color: #1960ab;
        left: 0;
        top: 0;
        z-index: 10;
        border-bottom: 1px solid #f1f1f1;
        .back{
            position: absolute;
            top: 0;
            left: 0.3rem;
            font-size: 0.6rem;
            color: #333;
        }
    }             
</style>   